import http from "../../../http-common-super-admin";

class ProductService {
  // ── Currency ─────────────────────────────────────────────────────────────────
  currencyList() {
    return http.get("/kids/currency/list");
  }
  createCurrency(data) {
    return http.post("/kids/currency/create", data);
  }
  updateCurrency(data) {
    return http.post("/kids/currency/update", data);
  }
  toggleCurrencyActive(data) {
    return http.post("/kids/currency/toggle-active", data);
  }
  deleteCurrency(data) {
    return http.delete("/kids/currency/delete", { params: data });
  }

  // ── Marketplace ───────────────────────────────────────────────────────────────
  marketplaceList() {
    return http.get("/kids/marketplace/list");
  }
  createMarketplace(data) {
    return http.post("/kids/marketplace/create", data);
  }
  updateMarketplace(data) {
    return http.post("/kids/marketplace/update", data);
  }
  toggleMarketplaceActive(data) {
    return http.post("/kids/marketplace/toggle-active", data);
  }
  setDefaultMarketplace(data) {
    return http.post("/kids/marketplace/set-default", data);
  }
  deleteMarketplace(data) {
    return http.delete("/kids/marketplace/delete", { params: data });
  }

  // ── Products ──────────────────────────────────────────────────────────────────
  productList() {
    return http.get("/kids/product/list");
  }
  getProductImages(data) {
    return http.get("/kids/product/images", { params: data });
  }
  uploadProductImages(formData) {
    return http.post("/kids/product/upload-product-images", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }
  deleteProductImage(data) {
    return http.delete("/kids/product/image", { params: data });
  }
  createProduct(data) {
    return http.post("/kids/product/create", data);
  }
  updateProduct(data) {
    return http.post("/kids/product/update", data);
  }
  deleteProduct(data) {
    return http.delete("/kids/product/delete", { params: data });
  }
  getOnetimeProducts() {
    return http.get("/kids/product/onetime");
  }

  // ── Product Prices ────────────────────────────────────────────────────────────
  getProductPrices(data) {
    return http.get("/kids/product/prices", { params: data });
  }
  addProductPrice(data) {
    return http.post("/kids/product/price/add", data);
  }
  setDefaultPrice(data) {
    return http.post("/kids/product/price/default", data);
  }

  // ── Colour Variants ───────────────────────────────────────────────────────────
  addColorVariant(data) {
    return http.post("/kids/product/color-variant/add", data);
  }
  updateColorVariant(data) {
    return http.post("/kids/product/color-variant/update", data);
  }
  deleteColorVariant(data) {
    return http.delete("/kids/product/color-variant/delete", { params: data });
  }
  deleteColorVariantImage(data) {
    return http.delete("/kids/product/color-variant/image/delete", {
      params: data,
    });
  }
  syncGoogleMerchant(data) {
    return http.post("/kids/product/google-merchant/sync", data);
  }
}

export default new ProductService();
